import Constants from '../utils/consts';

var http = require('follow-redirects').http;
var fs = require('fs');
var qs = require('querystring');


export default async function manageEvent(uname, token, clientId, deleteFlag, eventId, eventName, startDate, startHour, startMinutes,
    endDate, endHour, endMinutes, slotDuration, bannerImage, brokers_banner, brokersInvestorViewEnabled, 
    mailUser, mailPassword, infoLocation, conference_date, brokersInfoSchedulesEnabled, brokersInfoSchedulesCompaniesEnabled, notes, notesRaw, customBreaks, timezone, timezoneInformation) {
    return new Promise(function (resolve, reject) {

        var options = {
        'method': 'POST',
        'hostname': Constants.ipAddress,
        'path': '/apis/manageEvent.php',
        'headers': {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cookie': 'uid=e02675a1a7516909792f6850dffcd5fe'
        },
        'maxRedirects': 20
        };

        var req = http.request(options, function (res) {
        var chunks = [];

        res.on("data", function (chunk) {
            chunks.push(chunk);
        });

        res.on("end", function (chunk) {
            var body = Buffer.concat(chunks);
            console.log(body.toString());
            let asd = body.toString();
            resolve(JSON.parse(body.toString()));
        });

        res.on("error", function (error) {
            console.error(error);
        });
        });

        var postData = qs.stringify({
        'token': token,
        'uname': uname,
        'clientId' : clientId,
        'eventId' : eventId,
        'deleteFlag' : deleteFlag,
        'eventName' : eventName,
        'startDate' : startDate,
        'startHour' : startHour,
        'startMinutes' : startMinutes,
        'endDate' : endDate,
        'endHour' : endHour,
        'endMinutes' : endMinutes,
        'slotDuration' : slotDuration,
        'bannerImage' : bannerImage,
        'brokers_banner' : brokers_banner,
        'brokersInvestorViewEnabled' : brokersInvestorViewEnabled,
        'mailUser' : mailUser,
        'mailPassword' : mailPassword,
        'infoLocation' : infoLocation,
        'conference_date' : conference_date,
        'brokersInfoSchedulesEnabled' : brokersInfoSchedulesEnabled,
        'brokersInfoSchedulesCompaniesEnabled' : brokersInfoSchedulesCompaniesEnabled,
        'notes' : notes,
        'notesRaw' : notesRaw,
        'customBreaks' : customBreaks,
        'timezone' : timezone,
        'timezoneInformation' : timezoneInformation,
        
    });

        req.write(postData);

        req.end();

        
    });
}
